var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { customMap, createComponent, moment, TimePicker, DatePicker } from '../../dependencies';
var pickerMap = customMap(function (mapProps, _ref) {
  var _ref$input = _ref.input,
      _onChange = _ref$input.onChange,
      value = _ref$input.value,
      _onFocus = _ref$input.onFocus,
      _onBlur = _ref$input.onBlur,
      error = _ref.meta.error,
      displayFormat = _ref.displayFormat;

  if (!displayFormat) {
    console.warn('Property displayFormat is not set. Always set the property to prevent bugs!');
  }

  var date = moment(value);
  var lastChangeValue = null;
  return _extends({}, mapProps, {
    onChange: function onChange(_, v) {
      var val = moment(v, displayFormat);
      lastChangeValue = val;

      _onChange(val);
    },
    onFocus: function onFocus() {
      _onFocus();
    },
    onBlur: function onBlur() {
      _onBlur(lastChangeValue || value);
    },
    value: date.isValid() ? date : null,
    help: error,
    validateStatus: error ? 'error' : 'success',
    hasFeedback: false,
    format: displayFormat
  });
});

var picker = function picker(Picker) {
  return createComponent(Picker, pickerMap);
};

var TimePickerInput = picker(TimePicker);
var DatePickerInput = picker(DatePicker);
export { TimePickerInput, DatePickerInput };
export default picker;